import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as moment from 'moment';
import { fetchGlobalFeeDataAPI, addUpdateGlobalFeeDataAPI } from 'redux/actions/adminSupplierFeeMangement'
import { SupplierFeeManagementWrapper } from './SupplierFeeManagementStyles'
import GlobalFeeVariableTab from './GlobalFeeVariableTab'
import SupplierFeeTermsTab from './SupplierFeeTermsTab'
import AlertModal from 'web/components/AlertModal';
import Spinner from 'web/components/Spinner'

function SupplierFeeManagement() {
  const dispatch = useDispatch();
  let history = useHistory();
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
  const adminRoles = useSelector(state => state.admin.adminRoles)
  const token = localStorage.getItem("token");

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');

  const [selectedTab, setSelectedTab] = useState('global-tab')
  const [globalFeeVariableData, setGlobalFeeVariableData] = useState()

  const tabChangeHandler = e => {
    let selectedTab = e.target.id
    setSelectedTab(selectedTab)
  }

  useEffect(() => {
    getGlobalFeeVariableDataFunction()
  }, [])

  const getGlobalFeeVariableDataFunction = async () => {
    let response = await dispatch(fetchGlobalFeeDataAPI());
    if (response.success) {
      setGlobalFeeVariableData(response.data)
    } else {
      errorResHandle(response)
    }
  };

  const updateGlobalFeeFunc = async (formikValues) => {
    let data = {
      sellerFee: parseFloat(formikValues?.sellerFee),
      buyerFee: parseFloat(formikValues?.buyerFee),
      brokerFee: parseFloat(formikValues?.brokerFee),
      ptPlusSellerFee: parseFloat(formikValues?.ptPlusSellerFee),
      ptPlusBuyerFee: parseFloat(formikValues?.ptPlusBuyerFee),
      supplierTermDelivery: parseFloat(formikValues?.supplierTermDelivery),
      supplierTermPickup: parseFloat(formikValues?.supplierTermPickup),
      comments: formikValues?.comments
    }
    let response = await dispatch(addUpdateGlobalFeeDataAPI(data));
    if (response.success) {
      setModalContent(response.data?.msg)
      setModal(!modal)
      getGlobalFeeVariableDataFunction()
    } else {
      errorResHandle(response)
    }
  }

  const errorResHandle = (response) => {
    if (response.statusCode === 401) {
      localStorage.removeItem('token')
      history.push('/sign-in')
      window.location.reload(false);
    } else {
      setModalContent(response.message || 'Something went wrong, please try again!')
      setModal(!modal)
    }
  }

  return (
    <>
      {loaderVisible && <Spinner />}
      {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('SUPPLIER_FEE_MANAGEMENT'))) ?
        <SupplierFeeManagementWrapper>
          <div className='header-section'>
            <div className='tab-wrapper'>
              <p
                id='global-tab'
                className={`tab-name ${selectedTab === 'global-tab' ? 'active' : ''}`}
                onClick={tabChangeHandler}>
                Global System Fee & Terms
              </p>
              <p
                id='supplier-tab'
                className={`tab-name ${selectedTab === 'supplier-tab' ? 'active' : ''}`}
                onClick={tabChangeHandler}>
                Supplier Discount Program & Terms
              </p>
            </div>
          </div>
          {selectedTab === 'global-tab' && (
            <GlobalFeeVariableTab
              pageData={globalFeeVariableData}
              updateFee={updateGlobalFeeFunc}
            />
          )}
          {selectedTab === 'supplier-tab' && (
            <SupplierFeeTermsTab
              globalFeeData={globalFeeVariableData}
            />
          )}
          <div>

          </div>
        </SupplierFeeManagementWrapper>
        :
        <p>You are not authorized to view this page.</p>
      }
      <AlertModal
        isOpen={modal}
        toggle={() => setModal(!modal)}
        title=''
        content={modalContent}
      />
    </>
  )
}

export default SupplierFeeManagement